import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useAuth } from "../../authentication";
import { PermissionEnum } from "../../permissions";
import {
  ProductCategorySelect,
  ProductCategoryTypeEnum,
} from "../../product-categories";
import { StatusEnum, statusLabels } from "../../shared";
import { CustomInputField, CustomNumberField, CustomSelect } from "../../ui";
import { UnitOfMeasurementSelect } from "../../unit-of-measurements";

const GeneralInformationSection = ({
  disableStockKeepingUnitPrefix,
  variantsEnabled,
}) => {
  const { hasPermission } = useAuth();
  const {
    control,
    register,

    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            required
            control={control}
            name="name"
            label="Nama"
            register={register}
            helperText={errors.name?.message}
            InputProps={{ placeholder: "Cth: Frame X-1000" }}
            error={Boolean(errors.name)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            required
            disabled={disableStockKeepingUnitPrefix}
            control={control}
            name="stockKeepingUnitPrefix"
            label="SKU"
            register={register}
            helperText={errors.stockKeepingUnitPrefix?.message}
            error={Boolean(errors.stockKeepingUnitPrefix)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="productCategory"
            render={({ field, fieldState }) => (
              <ProductCategorySelect
                value={field.value}
                onChange={field.onChange}
                type={ProductCategoryTypeEnum.NON_LENS}
                isLeaf={true}
                TextFieldProps={{
                  required: true,
                  label: "Kategori",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="unitOfMeasurement"
            render={({ field, fieldState }) => (
              <UnitOfMeasurementSelect
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Unit",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="status"
            render={({ field, fieldState }) => (
              <CustomSelect
                required
                id="status"
                label="Status"
                options={Object.values(StatusEnum).map((value) => ({
                  value: value,
                  label: statusLabels[value],
                }))}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>
        {!variantsEnabled && (
          <>
            {hasPermission(PermissionEnum.UPDATE_PRODUCT_RETAIL_PRICE) && (
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Controller
                  control={control}
                  name="retailPrice"
                  render={({ field, fieldState }) => (
                    <CustomNumberField
                      value={field.value}
                      onChange={field.onChange}
                      required
                      label="Harga Retail"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
              </Grid>
            )}
            {hasPermission(PermissionEnum.UPDATE_PRODUCT_DISTRIBUTOR_PRICE) && (
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Controller
                  control={control}
                  name="distributorPrice"
                  render={({ field, fieldState }) => (
                    <CustomNumberField
                      value={field.value}
                      onChange={field.onChange}
                      required
                      label="Harga Distributor"
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  disableStockKeepingUnitPrefix: PropTypes.bool,
  variantsEnabled: PropTypes.bool,
};

export default GeneralInformationSection;
